import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../utils/auth';

// `permission` is a feature key from ROLE_PERMISSIONS (utils/auth.js) and must
// match the permission on the matching route in App.js. Items without one are
// visible to every signed-in user.
const NAV_ITEMS = [
  {
    path: '/on/dashboard',
    label: 'Dashboard',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    path: '/on/corps',
    label: 'Corporations',
    permission: 'corps',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
  },
  {
    path: '/on/clients',
    label: 'Clients',
    permission: 'clients',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    path: '/on/vendors',
    label: 'Vendors',
    permission: 'vendors',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    ),
  },
  {
    path: '/on/employees',
    label: 'Employees',
    permission: 'employees',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    path: '/on/orders',
    label: 'Orders',
    permission: 'order',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
        <line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    ),
  },
  {
    path: '/on/invoices',
    label: 'Invoices',
    permission: 'invoices',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    ),
  },
  {
    path: '/on/timesheets',
    label: 'Timesheets',
    permission: 'timesheets',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    path: '/on/expenses',
    label: 'Expenses',
    permission: 'expenses',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
        <circle cx="7" cy="15" r="1.5" />
      </svg>
    ),
  },
  {
    path: '/on/timesheet-items',
    label: 'Timesheet Items',
    permission: 'timesheetItems',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6" />
        <line x1="8" y1="12" x2="21" y2="12" />
        <line x1="8" y1="18" x2="21" y2="18" />
        <line x1="3" y1="6" x2="3.01" y2="6" />
        <line x1="3" y1="12" x2="3.01" y2="12" />
        <line x1="3" y1="18" x2="3.01" y2="18" />
      </svg>
    ),
  },
  {
    path: '/on/documents',
    label: 'Documents',
    permission: 'documents',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
];

// Account-level items shown in a separate group at the bottom of the sidebar.
const ACCOUNT_ITEMS = [
  {
    path: '/on/settings',
    label: 'Settings',
    icon: (
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
];

const NavItemLink = ({ item, active, collapsed }) => (
  <Link
    to={item.path}
    title={collapsed ? item.label : ''}
    aria-current={active ? 'page' : undefined}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: collapsed ? 0 : '12px',
      justifyContent: collapsed ? 'center' : 'flex-start',
      padding: collapsed ? '10px 0' : '10px 14px',
      borderRadius: 'var(--radius-md)',
      textDecoration: 'none',
      color: active ? 'var(--ink)' : 'var(--body-text)',
      background: active ? 'var(--surface-card)' : 'transparent',
      fontFamily: 'var(--font-sans)',
      fontSize: '14px',
      fontWeight: active ? 500 : 400,
      letterSpacing: 0,
      transition: 'background 0.16s, color 0.16s',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    }}
    onMouseOver={e => {
      if (!active) {
        e.currentTarget.style.background = 'var(--canvas)';
        e.currentTarget.style.color = 'var(--ink)';
      }
    }}
    onMouseOut={e => {
      if (!active) {
        e.currentTarget.style.background = 'transparent';
        e.currentTarget.style.color = 'var(--body-text)';
      }
    }}
  >
    <span style={{ color: active ? 'var(--coral)' : 'var(--muted)', flexShrink: 0, display: 'flex' }}>
      {item.icon}
    </span>
    {!collapsed && (
      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {item.label}
      </span>
    )}
  </Link>
);

const Sidebar = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const { hasPermission } = useAuth();

  const isActive = (path) => location.pathname.startsWith(path);

  const visibleItems = NAV_ITEMS.filter(
    item => !item.permission || hasPermission(item.permission)
  );

  return (
    <div style={{
      width: collapsed ? '64px' : '240px',
      minWidth: collapsed ? '64px' : '240px',
      transition: 'width 0.22s cubic-bezier(0.4,0,0.2,1), min-width 0.22s cubic-bezier(0.4,0,0.2,1)',
      background: 'var(--surface-soft)',
      borderRight: '1px solid var(--hairline)',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>

      {/* Toggle button row */}
      <div style={{
        padding: '18px 16px',
        display: 'flex',
        justifyContent: collapsed ? 'center' : 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid var(--hairline-soft)',
      }}>
        {!collapsed && (
          <span style={{
            fontFamily: 'var(--font-sans)',
            fontSize: '12px',
            fontWeight: 500,
            color: 'var(--muted)',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
          }}>
            Main Menu
          </span>
        )}
        <button
          onClick={onToggle}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          style={{
            background: 'transparent',
            border: '1px solid var(--hairline)',
            borderRadius: 'var(--radius-md)',
            width: '28px',
            height: '28px',
            padding: 0,
            cursor: 'pointer',
            color: 'var(--muted)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.16s, color 0.16s',
            flexShrink: 0,
          }}
          onMouseOver={e => { e.currentTarget.style.background = 'var(--canvas)'; e.currentTarget.style.color = 'var(--ink)'; }}
          onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--muted)'; }}
        >
          {collapsed
            ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
          }
        </button>
      </div>

      {/* Nav items */}
      <nav style={{ flex: 1, padding: '12px 12px', overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '2px' }}>
          {visibleItems.map((item) => (
            <li key={item.path}>
              <NavItemLink item={item} active={isActive(item.path)} collapsed={collapsed} />
            </li>
          ))}
        </ul>

        {/* Account group pinned to the bottom of the nav */}
        <ul style={{
          listStyle: 'none', margin: 'auto 0 0', padding: '12px 0 0',
          display: 'flex', flexDirection: 'column', gap: '2px',
          borderTop: '1px solid var(--hairline-soft)',
        }}>
          {ACCOUNT_ITEMS.map((item) => (
            <li key={item.path}>
              <NavItemLink item={item} active={isActive(item.path)} collapsed={collapsed} />
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      {!collapsed && (
        <div style={{
          padding: '16px 20px',
          borderTop: '1px solid var(--hairline-soft)',
          fontFamily: 'var(--font-sans)',
          fontSize: '12px',
          color: 'var(--muted-soft)',
          fontWeight: 400,
          letterSpacing: '0.2px',
        }}>
          © 2025 One Nexus
        </div>
      )}
    </div>
  );
};

export default Sidebar;
